var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import { Row } from "react-bootstrap";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import { injectIntl } from "@irati/utils/lang";
import Select from "@irati/ui/src/FormItem/Select";
import { updatePermissions } from "@irati/permissions/services/switchboard";
import SettingsLink from "./SettingsLink";
import { AreYouSurePopUp } from "../../AreYouSurePopUp";
var PermissionOption = /** @class */ (function (_super) {
    __extends(PermissionOption, _super);
    function PermissionOption(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (newValue) {
            _this.setState({
                newValue: newValue
            });
            _this.areYouSure.toggle();
        };
        _this.updateRecognitionPermissions = function () {
            var newValue = _this.state.newValue;
            var _a = _this.props, auth = _a.auth, action = _a.action;
            var uuid = auth.business.uuid;
            var data = {
                tenantId: uuid,
                action: action,
                teamId: null,
                option: newValue,
                values: []
            };
            return updatePermissions(data).then(function () {
                _this.setState({
                    value: newValue
                });
            });
        };
        _this.state = {
            value: props.value,
            newValue: null
        };
        return _this;
    }
    PermissionOption.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, description = _a.description, intl = _a.intl, options = _a.options, props = __rest(_a, ["title", "description", "intl", "options"]);
        var value = this.state.value;
        return (React.createElement(React.Fragment, null,
            React.createElement(SettingsLink, { title: title, value: description },
                React.createElement(Row, null,
                    React.createElement(Select, __assign({}, props, { options: options.map(function (option) { return (__assign(__assign({}, option), { label: intl.formatMessage({ id: option.label }) })); }), hideLabel: true, isClearable: false, isSearchable: false, onChange: function (newValue) { return _this.handleChange(newValue); }, value: value })))),
            React.createElement(AreYouSurePopUp, { ref: function (c) {
                    _this.areYouSure = c;
                }, onSubmit: this.updateRecognitionPermissions, text: intl.formatMessage({ id: "admin.components.areYouSurePopUp.text" }), cancelButtonText: intl.formatMessage({ id: "admin.components.areYouSurePopUp.button.cancel" }), buttonText: intl.formatMessage({ id: "admin.components.areYouSurePopUp.button.text" }) })));
    };
    return PermissionOption;
}(PureComponent));
export default injectIntl(withAuth(PermissionOption));
